import { ALLOWED_COMPANIES } from 'components/Registration/useCompanyRegistrationDE';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useLocale } from 'hooks/useLocale';

export enum ACTIONS {
  SUPPORT = 'SUPPORT',
  ACCOUNT = 'ACCOUNT',
  MOBILE_MENU = 'MOBILE_MENU',
  NOTIFICATION = 'NOTIFICATION',
  CLOSE = 'CLOSE',
}

type TReducerState = {
  isDropdownOpen: boolean;
  selectedDropdown: ACTIONS;
};

type TReducerAction = {
  type: ACTIONS;
};

export const initialReducerState = {
  isDropdownOpen: false,
  selectedDropdown: ACTIONS.CLOSE,
};

// Generic debouncer to prevent constant re-render
export const dropdownReducer = (
  state: TReducerState,
  action: TReducerAction,
) => {
  switch (action.type) {
    case ACTIONS.ACCOUNT:
    case ACTIONS.SUPPORT:
    case ACTIONS.MOBILE_MENU:
    case ACTIONS.NOTIFICATION:
      return {
        isDropdownOpen: true,
        selectedDropdown: action.type,
      };
    case ACTIONS.CLOSE:
    default:
      return {
        ...state,
        isDropdownOpen: false,
      };
  }
};

export function useInviteColleague() {
  const { introducerCompany } = useIntroducerContext();
  const { isDE } = useLocale();

  let canInviteColleague = true;
  let companyPath = null;

  if (introducerCompany?.shared_applications) {
    const allowedCompany =
      isDE &&
      ALLOWED_COMPANIES.find((c) => c.name === introducerCompany.company_name);

    canInviteColleague = Boolean(allowedCompany);
    companyPath = allowedCompany ? allowedCompany.id : null;
  }

  return { canInviteColleague, companyPath };
}
